import { Routes as DashboardRoutes } from "ui/modules/dashboard/navigation";
import { Routes as FleetVehicleRoutes } from "ui/modules/fleet/vehicles/navigation";
import { Routes as FleetWarehouseRoutes } from "ui/modules/fleet/warehouses/navigation";
import { Routes as FleetTireRoutes } from "ui/modules/fleet/tires/navigation";
import { Routes as FleetFireExtinguisherRoutes } from "ui/modules/fleet/fireExtinguishers/navigation";
import { Routes as FleetRegistrationRoutes } from "ui/modules/fleet/registrations/navigation";
import { Routes as FleetCascoRoutes } from "ui/modules/fleet/casco/navigation";
import { Routes as FleetTransferRoutes } from "ui/modules/fleet/transfers/navigation";
import { Routes as FleetDamageRoutes } from "ui/modules/fleet/damages/navigation";
import { Routes as FleetDriverRoutes } from "ui/modules/fleet/drivers/navigation";
import { Routes as FleetServiceRoutes } from "ui/modules/fleet/services/navigation";
import { Routes as UserRoutes } from "ui/modules/users/navigation";
import { Routes as SettingRoutes } from "ui/modules/settings/navigation";
import { Routes as ContactRoutes } from "ui/modules/contacts/navigation";
import { Routes as CalculationRoutes } from "ui/modules/calculation/navigation";
import { Routes as FinanceRoutes } from "ui/modules/finance/navigation";
import { Routes as PriceRoutes } from "ui/modules/prices/navigation";
import { Routes as ReportRoutes } from "ui/modules/reports/navigation";
import { Routes as IntegrationRoutes } from "ui/modules/integrations/navigation";
import { Routes as MarketplaceRoutes } from "ui/modules/marketplace/navigation";
import { Routes as NotificationRoutes } from "ui/modules/notifications/navigation";
import { Routes as SalesRoutes } from "ui/modules/sales/navigation";
import { PageTitle } from "./types";

/*------------------------------------------------------------------
  DASHBOARD
-------------------------------------------------------------------*/

export const DASHBOARD_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.dashboard", //Nadzorna ploča
  icon: "/media/icons/dashboard.svg",
  iconColor: "stroke-[#edeef8]",
  route: DashboardRoutes.DashboardRouter,
};

export const  DASHBOARD_WIDGET_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.dashboard.widget.add", 
  icon: "/media/icons/add.svg",
  iconColor: "stroke-[#edeef8]",
  route: DashboardRoutes.DashboardRouter,
};


/*------------------------------------------------------------------
  USER
-------------------------------------------------------------------*/

export const USER_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.user", //"Korisnici",
  icon: "/media/icons/user-search.svg",
  iconColor: "stroke-[#edeef8]",
  route: UserRoutes.UserSearchPageRouter,
};

export const USER_SEARCH_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.user.search", //"Pretraga korisnika",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: UserRoutes.UserSearchPageRouter,
};

export const USER_NEW_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.user.add", //"Unos korisnika",
  icon: "/media/icons/add.svg",
  iconColor: "stroke-[#edeef8]",
  route: UserRoutes.UserCreatePageRouter,
};

export const USER_EDIT_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.user.edit", //"Ažuriranje korisnika",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: UserRoutes.UserEditPageRouter,
};

export const USER_DETAIL_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.user.detail", //"Detalji korisnika",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: UserRoutes.UserDetailPageRouter,
};

/*------------------------------------------------------------------
  USER PERMISSION
-------------------------------------------------------------------*/

export const USER_PERMISSION_SEARCH_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.user.permission", //"Korisnička prava",
  icon: "/media/icons/user-search.svg",
  iconColor: "stroke-[#edeef8]",
  route: UserRoutes.UserPermissionSearchPageRouter,
};

export const USER_PERMISSION_CREATE_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.user.permission.create", //"Kreiranje postavki guma",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: UserRoutes.UserPermissionCreatePageRouter,
};

export const USER_PERMISSION_EDIT_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.user.permission.edit", //"Kreiranje postavki guma",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: UserRoutes.UserPermissionEditPageRouter,
};

/*------------------------------------------------------------------
  SETTINGS
-------------------------------------------------------------------*/

export const SETTING_DETAIL_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.setting.detail", //"Postavke",
  icon: "/media/icons/setting.svg",
  iconColor: "stroke-[#edeef8]",
  route: SettingRoutes.SettingDetailPageRouter,
};

/*------------------------------------------------------------------
  SETTINGS
-------------------------------------------------------------------*/

export const SETTING_DOCUMENT_DETAIL_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.setting.document.detail", //"Postavke",
  icon: "/media/icons/setting.svg",
  iconColor: "stroke-[#edeef8]",
  route: SettingRoutes.DocumentDetailPageRouter,
};


/*------------------------------------------------------------------
  REPORTS
-------------------------------------------------------------------*/
export const REPORT_SEARCH_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.report", //"Izvještaji",
  icon: "/media/icons/report.svg",
  iconColor: "stroke-indigo-400",
  route: ReportRoutes.ReportSearchPageRouter,
};

export const REPORT_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.report.detail", //"Izvještaj",
  icon: "/media/icons/report.svg",
  iconColor: "stroke-indigo-400",
  route: ReportRoutes.ReportDetailPageRouter,
};

/*------------------------------------------------------------------
  TRANSLATION
-------------------------------------------------------------------*/

export const APPLICATION_SETTINGS_PAGE_TITLE: PageTitle = {
  text: "Postavke aplikacije",
  icon: "/media/icons/setting.svg",
  iconColor: "stroke-[#edeef8]",
  route: SettingRoutes.SettingApplicationSettingsPageRouter,
};

export const SETTING_APPLICATION_DASHBOARD_PAGE_TITLE: PageTitle = {
  text: "Nadzorna ploča",
  icon: "/media/icons/setting.svg",
  iconColor: "stroke-[#edeef8]",
  route: SettingRoutes.SettingApplicationDashboardPageRouter,
};

export const TRANSLATION_SEARCH_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.translation.search", //"Prijevodi",
  icon: "/media/icons/languages.svg",
  iconColor: "stroke-[#edeef8]",
  route: SettingRoutes.TranslationSearchPageRouter,
};

export const TRANSLATION_NEW_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.translation.add", //"Unos prijevoda",
  icon: "/media/icons/add.svg",
  iconColor: "stroke-[#edeef8]",
  route: SettingRoutes.TranslationCreatePageRouter,
};

export const TRANSLATION_EDIT_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.translation.edit", //"Ažuriranje prijevoda",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: SettingRoutes.TranslationEditPageRouter,
};

export const TRANSLATION_DELETE_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.translation.delete", //"Brisanje prijevoda",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: SettingRoutes.TranslationDeletePageRouter,
};

/*------------------------------------------------------------------
  TENANTS (TENANTI)
-------------------------------------------------------------------*/

export const TENANT_SEARCH_PAGE_TITLE: PageTitle = {
  text: "Tenanti",
  icon: "/media/icons/company.svg",
  iconColor: "stroke-[#edeef8]",
  route: SettingRoutes.TenantSearchPageRouter,
};

export const TENANT_DETAIL_PAGE_TITLE: PageTitle = {
  text: "Detalji tenanta",
  icon: "/media/icons/company.svg",
  iconColor: "stroke-[#edeef8]",
  route: SettingRoutes.TenantDetailPageRouter,
};

/*------------------------------------------------------------------
  OFFICES (POSLOVNICE)
-------------------------------------------------------------------*/

export const OFFICES_SEARCH_PAGE_TITLE: PageTitle = {
  text: "Poslovnice",
  icon: "/media/icons/company.svg",
  iconColor: "stroke-[#edeef8]",
  route: SettingRoutes.OfficesSearchPageRouter,
};

export const OFFICE_EDIT_PAGE_TITLE: PageTitle = {
  text: "Unos poslovnice",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: SettingRoutes.OfficesSearchPageRouter,
};

export const OFFICE_DELETE_PAGE_TITLE: PageTitle = {
  text: "Brisanje poslovnice",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: SettingRoutes.OfficesSearchPageRouter,
};

/*------------------------------------------------------------------
  FLEET TIRE SET
-------------------------------------------------------------------*/

export const FLEET_TIRE_SET_SEARCH_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.tire.set.search", //"Pretraga guma",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetTireRoutes.FleetTireSetSearchPageRouter,
};

export const FLEET_TIRE_SET_NEW_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.tire.set.add", //"Unos ",
  icon: "/media/icons/add.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetTireRoutes.FleetTireCreatePageRouter,
};

export const FLEET_TIRE_SET_EDIT_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.tire.set.edit", //"Ažuriranje guma",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetTireRoutes.FleetTireEditPageRouter,
};

export const FLEET_TIRE_SET_DETAIL_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.tire.set.detail", //"Detalji vozila",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetTireRoutes.FleetTireDetailPageRouter,
};

/*------------------------------------------------------------------
  FLEET TIRE 
-------------------------------------------------------------------*/
export const FLEET_TIRE_SEARCH_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.tire.search", //"Pretraga guma",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetTireRoutes.FleetTireSearchPageRouter,
};

export const FLEET_TIRE_NEW_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.tire.add", //"Unos ",
  icon: "/media/icons/add.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetTireRoutes.FleetTireCreatePageRouter,
};

export const FLEET_TIRE_EDIT_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.tire.edit", //"Ažuriranje guma",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetTireRoutes.FleetTireEditPageRouter,
};

export const FLEET_TIRE_DETAIL_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.tire.detail", //"Detalji vozila",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetTireRoutes.FleetTireDetailPageRouter,
};

/*------------------------------------------------------------------
  FLEET VEHICLE 
-------------------------------------------------------------------*/
export const FLEET_VEHICLE_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.vehicle", //"Vozila",
  icon: "/media/icons/vehicle.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetVehicleRoutes.FleetVehicleSearchPageRouter,
};

export const FLEET_VEHICLE_SEARCH_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.vehicle.search", //"Pretraga vozila",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetVehicleRoutes.FleetVehicleSearchPageRouter,
};

export const FLEET_VEHICLE_NEW_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.vehicle.add", //"Unos",
  icon: "/media/icons/add.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetVehicleRoutes.FleetVehicleCreatePageRouter,
};

export const FLEET_VEHICLE_EDIT_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.vehicle.edit", // "Ažuriranje vozila",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetVehicleRoutes.FleetVehicleEditPageRouter,
};

export const FLEET_VEHICLE_DETAIL_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.vehicle.detail", //"Detalji vozila",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetVehicleRoutes.FleetVehicleEditPageRouter,
};

export const FLEET_VEHICLE_WIDGET_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.vehicle.widget.detail", //"Detalji vozila",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetVehicleRoutes.FleetVehicleEditPageRouter,
};



/*------------------------------------------------------------------
  FLEET VEHICLE PICTURE
-------------------------------------------------------------------*/
export const FLEET_VEHICLE_PICTURE_CREATE_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.vehicle.picture.add", //"Pregled troškova",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetVehicleRoutes.FleetVehiclePictureCreatePageRouter,
};

export const FLEET_VEHICLE_PICTURE_EDIT_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.vehicle.picture.edit", //"Pregled troškova",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetVehicleRoutes.FleetVehiclePictureEditPageRouter,
};

export const FLEET_VEHICLE_PICTURE_UPLOAD_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.vehicle.picture.upload", //"upload slike",
  icon: "/media/images/add-icon.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetVehicleRoutes.FleetVehiclePictureEditPageRouter,
};

export const FLEET_VEHICLE_PICTURE_PREVIEW_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.vehicle.picture.preview", //"upload slike",
  icon: "/media/images/add-icon.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetVehicleRoutes.FleetVehiclePictureEditPageRouter,
};


/*------------------------------------------------------------------
  FLEET VEHICLE DOCUMENT
-------------------------------------------------------------------*/

export const FLEET_VEHICLE_DOCUMENT_SEARCH_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.vehicle.document.search", //"Pregled dokumenata",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetVehicleRoutes.FleetVehicleDocumentSearchPageRouter,
};

export const FLEET_VEHICLE_DOCUMENT_CREATE_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.vehicle.document.add", //"Pregled dokumenata",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetVehicleRoutes.FleetVehicleDocumentCreatePageRouter,
};

export const FLEET_VEHICLE_DOCUMENT_EDIT_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.vehicle.document.edit", //"Pregled dokumenata",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetVehicleRoutes.FleetVehicleDocumentEditPageRouter,
};


export const FLEET_VEHICLE_DOCUMENT_UPLOAD_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.vehicle.document.upload", //"Pregled dokumenata",
  icon: "/media/images/add-icon.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetVehicleRoutes.FleetVehicleDocumentEditPageRouter,
};

/*------------------------------------------------------------------
  FLEET VEHICLE EXPENSE
-------------------------------------------------------------------*/
export const FLEET_VEHICLE_EXPENSE_SEARCH_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.vehicle.expense.search", //"Pregled dokumenata",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetVehicleRoutes.FleetVehicleExpenseSearchPageRouter,
};

export const FLEET_VEHICLE_EXPENSE_CREATE_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.vehicle.expense.add", //"Pregled troškova",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetVehicleRoutes.FleetVehicleExpenseCreatePageRouter,
};

export const FLEET_VEHICLE_EXPENSE_EDIT_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.vehicle.expense.edit", //"Pregled troškova",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetVehicleRoutes.FleetVehicleExpenseEditPageRouter,
};

/*------------------------------------------------------------------
  FLEET VEHICLE DAMAGE CLAIM
-------------------------------------------------------------------*/
export const FLEET_VEHICLE_DAMAGE_SEARCH_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.vehicle.damage.search",
  icon: "/media/icons/alert-triangle.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetVehicleRoutes.FleetVehicleDamageSearchPageRouter,
};

/*------------------------------------------------------------------
  FLEET VEHICLE INVOICE
-------------------------------------------------------------------*/
export const FLEET_VEHICLE_INVOICE_SEARCH_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.vehicle.invoice.search", //"Pregled računa",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetVehicleRoutes.FleetVehicleInvoiceSearchPageRouter,
};

export const FLEET_VEHICLE_INVOICE_EDIT_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.vehicle.invoice.edit",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetVehicleRoutes.FleetVehicleInvoiceEditPageRouter,
};

export const FLEET_VEHICLE_INVOICE_CREATE_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.vehicle.invoice.add",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetVehicleRoutes.FleetVehicleInvoiceCreatePageRouter,
};

/*------------------------------------------------------------------
 FLEET VEHICLE OFFER
-------------------------------------------------------------------*/
export const FLEET_VEHICLE_OFFER_SEARCH_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.vehicle.offer.search", 
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetVehicleRoutes.FleetVehicleOfferSearchPageRouter,
};


export const FLEET_VEHICLE_OFFER_SALE_EDIT_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.vehicle.offer.sale.edit", 
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetVehicleRoutes.FleetVehicleOfferSaleEditPageRouter,
};


export const FLEET_VEHICLE_OFFER_SALE_CREATE_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.vehicle.offer.sale.add",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetVehicleRoutes.FleetVehicleOfferSaleCreatePageRouter,
};


export const FLEET_VEHICLE_OFFER_RENT_EDIT_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.vehicle.offer.rent.edit",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: "",
};


export const FLEET_VEHICLE_OFFER_RENT_CREATE_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.vehicle.offer.rent.add",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: "",
};


/*------------------------------------------------------------------
 FLEET VEHICLE CONTRACT
-------------------------------------------------------------------*/
export const FLEET_VEHICLE_CONTRACT_SEARCH_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.vehicle.contract.search", //"Pregled ugovora",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetVehicleRoutes.FleetVehicleContractSearchPageRouter,
};

export const FLEET_VEHICLE_CONTRACT_SALE_CREATE_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.vehicle.contract.sale.add", 
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetVehicleRoutes.FleetVehicleContractSaleCreatePageRouter,
};

export const FLEET_VEHICLE_CONTRACT_SALE_EDIT_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.vehicle.contract.sale.edit",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetVehicleRoutes.FleetVehicleContractSaleEditPageRouter,
};

export const FLEET_VEHICLE_CONTRACT_RENT_CREATE_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.vehicle.contract.rent.add",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetVehicleRoutes.FleetVehicleContractSearchPageRouter,
};

export const FLEET_VEHICLE_CONTRACT_RENT_EDIT_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.vehicle.contract.rent.edit",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetVehicleRoutes.FleetVehicleContractSearchPageRouter,
};

/*------------------------------------------------------------------
  FLEET VEHICLE TIRE SET
-------------------------------------------------------------------*/
// export const FLEET_TIRE_PAGE_TITLE: PageTitle = {
//   text: "admin.sidebar.fleet.tire",
//   icon: "/media/icons/tire.svg",
//   iconColor: "stroke-[#edeef8]",
//   route: FleetTireRoutes.FleetTireSetSearchPageRouter,
// };

// export const FLEET_VEHICLE_TIRE_SEARCH_PAGE_TITLE: PageTitle = {
//   text: "admin.sidebar.fleet.vehicle.tire.search", 
//   icon: "/media/icons/search.svg",
//   iconColor: "stroke-[#edeef8]",
//   route: FleetVehicleRoutes.FleetVehicleTireSearchPageRouter,
// };

// export const FLEET_VEHICLE_TIRE_CREATE_PAGE_TITLE: PageTitle = {
//   text: "admin.sidebar.fleet.vehicle.tire.add", 
//   icon: "/media/icons/search.svg",
//   iconColor: "stroke-[#edeef8]",
//   route: FleetVehicleRoutes.FleetVehicleTireCreatePageRouter,
// };

// export const FLEET_VEHICLE_TIRE_EDIT_PAGE_TITLE: PageTitle = {
//   text: "admin.sidebar.fleet.vehicle.tire.edit",
//   icon: "/media/icons/search.svg",
//   iconColor: "stroke-[#edeef8]",
//   route: FleetVehicleRoutes.FleetVehicleTireEditPageRouter,
// };


/*------------------------------------------------------------------
  FLEET VEHICLE TIRE SET
-------------------------------------------------------------------*/

export const FLEET_TIRE_SET_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.tire.set",
  icon: "/media/icons/tire.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetTireRoutes.FleetTireSetSearchPageRouter,
};

export const FLEET_VEHICLE_TIRE_SET_SEARCH_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.vehicle.tire.set.search", 
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetVehicleRoutes.FleetVehicleTireSetSearchPageRouter,
};

export const FLEET_VEHICLE_TIRE_SET_CREATE_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.vehicle.tire.set.add", 
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetVehicleRoutes.FleetVehicleTireSetCreatePageRouter,
};

export const FLEET_VEHICLE_TIRE_SET_EDIT_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.vehicle.tire.set.edit", 
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetVehicleRoutes.FleetVehicleTireSetEditPageRouter,
};

export const FLEET_VEHICLE_TIRE_SET_DOCUMENT_UPLOAD_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.vehicle.tire.set.document.upload",
  icon: "/media/images/add-icon.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetVehicleRoutes.FleetVehicleTireSetDocumentEditPageRouter,
};

/*------------------------------------------------------------------
  FLEET VEHICLE FIRE EXTINGUISHERS
-------------------------------------------------------------------*/
export const FLEET_VEHICLE_FIRE_EXTINGUISHER_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.fireextinguisher",
  icon: "/media/icons/tire.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetVehicleRoutes.FleetVehicleFireExtinguisherSearchPageRouter,
};

export const FLEET_FIRE_EXTINGUISHER_SEARCH_PAGE_TITLE: PageTitle = {
  text: "Vatrogasni aparati",
  icon: "/media/icons/fire-extinguisher.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetFireExtinguisherRoutes.FireExtinguisherSearchPageRouter,
};

export const FLEET_REGISTRATION_EXPIRY_SEARCH_PAGE_TITLE: PageTitle = {
  text: "Istek registracije",
  icon: "/media/icons/calendar.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetRegistrationRoutes.RegistrationExpirySearchPageRouter,
};

export const FLEET_CASCO_EXPIRY_SEARCH_PAGE_TITLE: PageTitle = {
  text: "Kasko",
  icon: "/media/icons/shield.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetCascoRoutes.CascoExpirySearchPageRouter,
};

export const FLEET_DAMAGE_SEARCH_PAGE_TITLE: PageTitle = {
  text: "Štete",
  icon: "/media/icons/damage.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetDamageRoutes.DamageSearchPageRouter,
};

export const FLEET_DRIVER_SEARCH_PAGE_TITLE: PageTitle = {
  text: "Vozači",
  icon: "/media/icons/user-search.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetDriverRoutes.DriverSearchPageRouter,
};

export const FLEET_SERVICE_SEARCH_PAGE_TITLE: PageTitle = {
  text: "Servisi",
  icon: "/media/icons/service.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetServiceRoutes.ServiceSearchPageRouter,
};

export const FLEET_TRANSFER_SEARCH_PAGE_TITLE: PageTitle = {
  text: "Transferi",
  icon: "/media/icons/location.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetTransferRoutes.TransferSearchPageRouter,
};

export const FLEET_VEHICLE_FIRE_EXTINGUISHER_SEARCH_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.vehicle.fireextinguisher.search",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetVehicleRoutes.FleetVehicleFireExtinguisherSearchPageRouter,
};

export const FLEET_VEHICLE_FIRE_EXTINGUISHER_CREATE_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.vehicle.fireextinguisher.add",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetVehicleRoutes.FleetVehicleFireExtinguisherCreatePageRouter,
};

export const FLEET_VEHICLE_FIRE_EXTINGUISHER_EDIT_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.vehicle.fireextinguisher.edit",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetVehicleRoutes.FleetVehicleFireExtinguisherEditPageRouter,
};

/*------------------------------------------------------------------
  FLEET WAREHOUSE
-------------------------------------------------------------------*/

export const FLEET_WAREHOUSE_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.warehouse",
  icon: "/media/icons/warehouse.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetWarehouseRoutes.FleetWarehouseSearchPageRouter,
};

export const FLEET_WAREHOUSE_SEARCH_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.warehouse.search",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetWarehouseRoutes.FleetWarehouseSearchPageRouter,
};

export const FLEET_WAREHOUSE_CREATE_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.warehouse.add",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetWarehouseRoutes.FleetWarehouseCreatePageRouter,
};

export const FLEET_WAREHOUSE_EDIT_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.warehouse.edit",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetWarehouseRoutes.FleetWarehouseEditPageRouter,
};

export const FLEET_WAREHOUSE_DETAIL_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.warehouse.detail", //"Detalji skladišta",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetVehicleRoutes.FleetVehicleDetailPageRouter,
};

/*------------------------------------------------------------------
  FLEET VEHICLE DRIVER
-------------------------------------------------------------------*/
export const FLEET_VEHICLE_DRIVER_SEARCH_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.vehicle.driver.search", //"Pregled vozača",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetVehicleRoutes.FleetVehicleDriverSearchPageRouter,
};

export const FLEET_VEHICLE_DRIVER_CREATE_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.vehicle.driver.add", //"Pregled troškova",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetVehicleRoutes.FleetVehicleDriverCreatePageRouter,
};

export const FLEET_VEHICLE_DRIVER_EDIT_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.fleet.vehicle.driver.edit", //"Pregled troškova",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: FleetVehicleRoutes.FleetVehicleDriverEditPageRouter,
};

/*------------------------------------------------------------------
  CONTACT 
-------------------------------------------------------------------*/
export const CONTACT_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.contact", //"Kontakti",
  icon: "/media/icons/contact.svg",
  iconColor: "stroke-[#edeef8]",
  route: ContactRoutes.ContactSearchPageRouter,
};

export const CONTACT_SEARCH_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.contact.search", // "Pretraga kontakata",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: ContactRoutes.ContactSearchPageRouter,
};

export const CONTACT_NEW_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.contact.add", // "Unos",
  icon: "/media/icons/add.svg",
  iconColor: "stroke-[#edeef8]",
  route: ContactRoutes.ContactNewPageRouter,
};

export const CONTACT_EDIT_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.contact.edit", //"Ažuriranje kontakata",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: ContactRoutes.ContactEditPageRouter,
};

export const CONTACT_DETAIL_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.contact.detail", //"Detalji kontakta",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: ContactRoutes.ContactEditPageRouter,
};

export const CONTACT_WIDGET_PAGE_TITLE: PageTitle = {
  text: "admin.contact.widget.title",
  icon: "/media/icons/setting.svg",
  iconColor: "stroke-[#edeef8]",
  route: ContactRoutes.ContactDetailPageRouter,
};

/*------------------------------------------------------------------
  CONTACT IMPORT
-------------------------------------------------------------------*/
export const CONTACT_IMPORT_XLS_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.contact.import.xls", //"Pregled email adresa",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: ContactRoutes.ContactImportXlsPageRouter,
};

/*------------------------------------------------------------------
  CONTACT EXPORT
-------------------------------------------------------------------*/
export const CONTACT_EXPORT_XLS_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.contact.export.xls", //"Pregled email adresa",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: ContactRoutes.ContactExportXlsPageRouter,
};

/*------------------------------------------------------------------
  CONTACT EMAIL
-------------------------------------------------------------------*/
export const CONTACT_EMAIL_SEARCH_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.contact.email.search", //"Pregled email adresa",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: ContactRoutes.ContactEmailSearchPageRouter,
};

export const CONTACT_EMAIL_CREATE_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.contact.email.add", // "Unos",
  icon: "/media/icons/add.svg",
  iconColor: "stroke-[#edeef8]",
  route: ContactRoutes.ContactNewPageRouter,
};

export const CONTACT_EMAIL_EDIT_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.contact.email.edit", //"Ažuriranje kontakata",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: ContactRoutes.ContactEditPageRouter,
};

/*------------------------------------------------------------------
  CONTACT PHONE
-------------------------------------------------------------------*/
export const CONTACT_PHONE_SEARCH_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.contact.phone.search", //"Pregled telefona",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: ContactRoutes.ContactPhoneSearchPageRouter,
};

export const CONTACT_PHONE_CREATE_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.contact.phone.add", // "Unos",
  icon: "/media/icons/add.svg",
  iconColor: "stroke-[#edeef8]",
  route: ContactRoutes.ContactNewPageRouter,
};

export const CONTACT_PHONE_EDIT_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.contact.phone.edit", //"Ažuriranje kontakata",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: ContactRoutes.ContactEditPageRouter,
};

/*------------------------------------------------------------------
  CONTACT ADDRESS
-------------------------------------------------------------------*/
export const CONTACT_ADDRESS_SEARCH_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.contact.address.search", //"Pregled adrese",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: ContactRoutes.ContactAddressSearchPageRouter,
};

export const CONTACT_ADDRESS_CREATE_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.contact.address.add", // "Unos",
  icon: "/media/icons/add.svg",
  iconColor: "stroke-[#edeef8]",
  route: ContactRoutes.ContactNewPageRouter,
};

export const CONTACT_ADDRESS_EDIT_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.contact.address.edit", //"Ažuriranje kontakata",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: ContactRoutes.ContactEditPageRouter,
};

/*------------------------------------------------------------------
  CONTACT NOTE
-------------------------------------------------------------------*/
export const CONTACT_NOTE_SEARCH_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.contact.note.search", //"Pregled bilješki",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: ContactRoutes.ContactNoteSearchPageRouter,
};

export const CONTACT_NOTE_CREATE_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.contact.note.add", // "Unos",
  icon: "/media/icons/add.svg",
  iconColor: "stroke-[#edeef8]",
  route: ContactRoutes.ContactNoteSearchPageRouter,
};

export const CONTACT_NOTE_EDIT_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.contact.note.edit", //"Ažuriranje bilješke",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: ContactRoutes.ContactNoteSearchPageRouter,
};

/*------------------------------------------------------------------
  FINANCE 
-------------------------------------------------------------------*/
export const FINANCE_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.finance", 
  icon: "/media/icons/finance.svg",
  iconColor: "stroke-[#edeef8]",
  route: FinanceRoutes.OfferSearchPageRouter,
};

export const OFFER_SEARCH_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.finance.offer.search", 
  icon: "/media/icons/offer.svg",
  iconColor: "stroke-[#edeef8]",
  route: FinanceRoutes.OfferSearchPageRouter,
};

export const OFFER_SALE_EDIT_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.finance.offer.sale.edit", 
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: FinanceRoutes.OfferSaleEditPageRouter,
};


export const OFFER_SALE_CREATE_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.finance.offer.sale.add",
  icon: "/media/icons/offer.svg",
  iconColor: "stroke-[#edeef8]",
  route: FinanceRoutes.OfferSaleCreatePageRouter,
};

/*------------------------------------------------------------------
  CONTRACT
-------------------------------------------------------------------*/
export const CONTRACT_SEARCH_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.finance.contract.search",
  icon: "/media/icons/contract.svg",
  iconColor: "stroke-[#edeef8]",
  route: FinanceRoutes.ContractSearchPageRouter,
};

export const CONTRACT_SALE_EDIT_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.finance.contract.sale.edit",
  icon: "/media/icons/contract.svg",
  iconColor: "stroke-[#edeef8]",
  route: FinanceRoutes.ContractSaleEditPageRouter,
};

export const CONTRACT_SALE_CREATE_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.finance.contract.sale.add",
  icon: "/media/icons/contract.svg",
  iconColor: "stroke-[#edeef8]",
  route: FinanceRoutes.ContractSaleCreatePageRouter,
};

/*------------------------------------------------------------------
  INVOICE
-------------------------------------------------------------------*/
export const INVOICE_SEARCH_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.finance.invoice.search",
  icon: "/media/icons/invoice.svg",
  iconColor: "stroke-[#edeef8]",
  route: FinanceRoutes.InvoiceSearchPageRouter,
};

export const DOCUMENT_SEARCH_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.finance.document.search",
  icon: "/media/icons/document.svg",
  iconColor: "stroke-[#edeef8]",
  route: FinanceRoutes.DocumentSearchPageRouter,
};

export const EXPENSE_SEARCH_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.finance.expense.search",
  icon: "/media/icons/expense.svg",
  iconColor: "stroke-[#edeef8]",
  route: FinanceRoutes.ExpenseSearchPageRouter,
};

export const USAGE_SEARCH_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.finance.usage.search",
  icon: "/media/icons/calculator.svg",
  iconColor: "stroke-[#edeef8]",
  route: FinanceRoutes.UsageSearchPageRouter,
};

export const FINANCIAL_OVERVIEW_PAGE_TITLE: PageTitle = {
  text: "Financijski pregled", // literal (DB nema ovaj prijevod; t() fallback = ključ)
  icon: "/media/icons/finance.svg",
  iconColor: "stroke-[#edeef8]",
  route: ReportRoutes.FinancialOverviewPageRouter,
};

export const INVOICE_EDIT_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.finance.invoice.edit",
  icon: "/media/icons/invoice.svg",
  iconColor: "stroke-[#edeef8]",
  route: FinanceRoutes.InvoiceEditPageRouter,
};

export const INVOICE_CREATE_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.finance.invoice.add",
  icon: "/media/icons/invoice.svg",
  iconColor: "stroke-[#edeef8]",
  route: FinanceRoutes.InvoiceCreatePageRouter,
};

/*------------------------------------------------------------------
  CALCULATOR
-------------------------------------------------------------------*/
export const CALCULATION_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.calculation", //"Kalkulacije",
  icon: "/media/icons/calculator.svg",
  iconColor: "stroke-[#edeef8]",
  route: CalculationRoutes.CalculationSearchPageRouter,
};

export const CALCULATION_SEARCH_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.calculation.search", //"Pretraga",
  icon: "/media/icons/calculator.svg",
  iconColor: "stroke-[#edeef8]",
  route: CalculationRoutes.CalculationSearchPageRouter,
};

export const CALCULATION_DETAIL_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.calculation.detail", //"Pregled kalkulacije",
  icon: "/media/icons/calculator.svg",
  iconColor: "stroke-[#edeef8]",
  route: CalculationRoutes.CalculationDetailPageRouter,
};

export const CALCULATION_CREATE_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.calculation.create", //"Kreiranje izračuna",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: CalculationRoutes.CalculationSearchPageRouter,
};

export const CALCULATION_EDIT_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.calculation.edit", //"Ažuriranje postojeće izračuna",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: CalculationRoutes.CalculationSearchPageRouter,
};

export const CALCULATION_RESULT_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.calculation.result", //"Rezultat izračuna",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: CalculationRoutes.CalculationResultPageRouter,
};

/*------------------------------------------------------------------
  CALCULATION SETTING
-------------------------------------------------------------------*/

export const CALCULATION_SETTING_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.calculation.setting", //"Postavke kalkulacije",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: CalculationRoutes.CalculationSettingPageRouter,
};

export const CALCULATION_SETTING_EDIT_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.calculation.setting.edit", //"Ažuriranje postavki",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: "",
};

/*------------------------------------------------------------------
  CALCULATION LEASING SETTING
-------------------------------------------------------------------*/

export const CALCULATION_LEASING_SEARCH_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.calculation.leasing.search", // "Pretraga leasing postavki",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: CalculationRoutes.CalculationLeasingSearchPageRouter,
};

export const CALCULATION_LEASING_CREATE_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.calculation.leasing.create", // "Kreiranje leasing postavki",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: CalculationRoutes.CalculationLeasingCreatePageRouter,
};

export const CALCULATION_LEASING_EDIT_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.calculation.leasing.edit", // "Ažuriranje leasing postavki",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: CalculationRoutes.CalculationLeasingEditPageRouter,
};

export const CALCULATION_LEASING_DETAIL_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.calculation.leasing.detail", // "Pregled leasinga",
  icon: "/media/icons/add.svg",
  iconColor: "stroke-[#edeef8]",
  route: CalculationRoutes.CalculationLeasingDetailPageRouter,
};

/*------------------------------------------------------------------
  CALCULATION RESIDUAL VALUE
-------------------------------------------------------------------*/

export const CALCULATION_RESIDUAL_VALUE_SEARCH_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.calculation.residualvalue.search", //"Pretraga tablica ostatka vrijednosti",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: CalculationRoutes.CalculationResidualValueSearchPageRouter,
};

export const CALCULATION_RESIDUAL_VALUE_CREATE_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.calculation.residualvalue.create", //"Kreiranje tablica ostatka vrijednosti",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: CalculationRoutes.CalculationResidualValueCreatePageRouter,
};

export const CALCULATION_RESIDUAL_VALUE_EDIT_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.calculation.residualvalue.edit", //"Ažuriranje tablice ostatka vrijednosti",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: CalculationRoutes.CalculationResidualValueEditPageRouter,
};

export const CALCULATION_RESIDUAL_VALUE_DETAIL_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.calculation.residualvalue.detail", //"Pregled tablice ostatka vrijednosti",
  icon: "/media/icons/add.svg",
  iconColor: "stroke-[#edeef8]",
  route: CalculationRoutes.CalculationResidualValueDetailPageRouter,
};

/*------------------------------------------------------------------
  CALCULATION TIRE
-------------------------------------------------------------------*/

export const CALCULATION_TIRE_SEARCH_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.calculation.tire.search", //"Pretraga guma",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: CalculationRoutes.CalculationTireSearchPageRouter,
};

export const CALCULATION_TIRE_CREATE_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.calculation.tire.create", //"Kreiranje postavki guma",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: CalculationRoutes.CalculationTireCreatePageRouter,
};

export const CALCULATION_TIRE_EDIT_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.calculation.tire.edit", //"Ažuriranje postavki guma",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: CalculationRoutes.CalculationTireEditPageRouter,
};

export const CALCULATION_TIRE_DETAIL_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.calculation.tire.detail", //"Pregled guma",
  icon: "/media/icons/add.svg",
  iconColor: "stroke-[#edeef8]",
  route: CalculationRoutes.CalculationTireDetailPageRouter,
};

/*------------------------------------------------------------------
  CALCULATION VEHICLE GROUP SETTING
-------------------------------------------------------------------*/

export const CALCULATION_VEHICLE_GROUP_SEARCH_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.calculation.vehiclegroup.search", //"Pretraga grupa vozila",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: CalculationRoutes.CalculationVehicleGroupSearchPageRouter,
};

export const CALCULATION_VEHICLE_GROUP_CREATE_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.calculation.vehiclegroup.create", //"Kreiranje grupa vozila",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: CalculationRoutes.CalculationVehicleGroupCreatePageRouter,
};

export const CALCULATION_VEHICLE_GROUP_EDIT_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.calculation.vehiclegroup.edit", // "Ažuriranje grupe vozila",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: CalculationRoutes.CalculationVehicleGroupEditPageRouter,
};

export const CALCULATION_VEHICLE_GROUP_DETAIL_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.calculation.vehiclegroup.detail", //"Pregled grupa",
  icon: "/media/icons/add.svg",
  iconColor: "stroke-[#edeef8]",
  route: CalculationRoutes.CalculationVehicleGroupDetailPageRouter,
};

/*------------------------------------------------------------------
  CALCULATION TEHNICAL INSPECTION SETTING
-------------------------------------------------------------------*/

export const CALCULATION_TEHNICAL_INSPECTION_SEARCH_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.calculation.tehnicalinspection.search", //"Pretraga tehničkih pregleda",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: CalculationRoutes.CalculationTehnicalInspectionSearchPageRouter,
};

export const CALCULATION_TEHNICAL_INSPECTION_CREATE_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.calculation.tehnicalinspection.create", //"Kreiranje tehničkih pregleda",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: CalculationRoutes.CalculationTehnicalInspectionCreatePageRouter,
};

export const CALCULATION_TEHNICAL_INSPECTION_EDIT_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.calculation.tehnicalinspection.edit", //"Ažuriranje tehničkih pregleda",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: CalculationRoutes.CalculationTehnicalInspectionEditPageRouter,
};

export const CALCULATION_TEHNICAL_INSPECTION_DETAIL_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.calculation.tehnicalinspection.detail", //"Pregled tehničkog pregleda",
  icon: "/media/icons/add.svg",
  iconColor: "stroke-[#edeef8]",
  route: CalculationRoutes.CalculationTehnicalInspectionDetailPageRouter,
};

/*------------------------------------------------------------------
  CALCULATION ANNUAL TAX SETTING
-------------------------------------------------------------------*/

export const CALCULATION_ANNUAL_TAX_SEARCH_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.calculation.annualtax.search", //"Pretraga godišnjih poreza",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: CalculationRoutes.CalculationAnnualTaxSearchPageRouter,
};

export const CALCULATION_ANNUAL_TAX_CREATE_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.calculation.annualtax.create", //"Kreiranje godišnjih poreza",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: CalculationRoutes.CalculationAnnualTaxCreatePageRouter,
};

export const CALCULATION_ANNUAL_TAX_EDIT_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.calculation.annualtax.edit", //"Ažuriranje godišnjih poreza",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: CalculationRoutes.CalculationAnnualTaxEditPageRouter,
};

export const CALCULATION_ANNUAL_TAX_DETAIL_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.calculation.annualtax.detail", //"Pregled godišnjih poreza",
  icon: "/media/icons/add.svg",
  iconColor: "stroke-[#edeef8]",
  route: CalculationRoutes.CalculationAnnualTaxDetailPageRouter,
};

/*------------------------------------------------------------------
  CALCULATION VEHICLE INSURANCE SETTING
-------------------------------------------------------------------*/

export const CALCULATION_VEHICLE_INSURANCE_SEARCH_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.calculation.vehicleinsurance.search", //"Pretraga postavki auto osiguranja",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: CalculationRoutes.CalculationVehicleInsuranceSearchPageRouter,
};

export const CALCULATION_VEHICLE_INSURANCE_CREATE_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.calculation.vehicleinsurance.create", //"Kreiranje postavki auto osiguranja",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: CalculationRoutes.CalculationVehicleInsuranceCreatePageRouter,
};

export const CALCULATION_VEHICLE_INSURANCE_EDIT_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.calculation.vehicleinsurance.edit", //"Ažuriranje postavki auto osiguranja",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: CalculationRoutes.CalculationVehicleInsuranceEditPageRouter,
};

export const CALCULATION_VEHICLE_INSURANCE_DETAIL_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.calculation.vehicleinsurance.detail", //"Pregled postavki auto osiguranja",
  icon: "/media/icons/add.svg",
  iconColor: "stroke-[#edeef8]",
  route: CalculationRoutes.CalculationVehicleInsuranceDetailPageRouter,
};

/*------------------------------------------------------------------
  CALCULATION TOLL SETTING
-------------------------------------------------------------------*/

export const CALCULATION_TOLL_SEARCH_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.calculation.toll.search", //"Pretraga cestarina",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: CalculationRoutes.CalculationTollSearchPageRouter,
};

export const CALCULATION_TOLL_CREATE_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.calculation.toll.create", //"Kreiranje cestarina",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: CalculationRoutes.CalculationTollCreatePageRouter,
};

export const CALCULATION_TOLL_EDIT_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.calculation.toll.edit", //"Ažuriranje cestarina",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: CalculationRoutes.CalculationTollEditPageRouter,
};

export const CALCULATION_TOLL_DETAIL_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.calculation.toll.detail", //"Pregled cestarina",
  icon: "/media/icons/add.svg",
  iconColor: "stroke-[#edeef8]",
  route: CalculationRoutes.CalculationTollDetailPageRouter,
};

/*------------------------------------------------------------------
  CALCULATION VEHICLE_SERVICES SETTING
-------------------------------------------------------------------*/

export const CALCULATION_VEHICLE_SERVICES_SEARCH_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.calculation.vehicleservices.search", //"Pretraga servisa",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: CalculationRoutes.CalculationVehicleServicesSearchPageRouter,
};

export const CALCULATION_VEHICLE_SERVICES_CREATE_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.calculation.vehicleservices.create", // "Kreiranje servisa",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: CalculationRoutes.CalculationVehicleServicesCreatePageRouter,
};

export const CALCULATION_VEHICLE_SERVICES_EDIT_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.calculation.vehicleservices.edit", //"Ažuriranje servisa",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: CalculationRoutes.CalculationVehicleServicesEditPageRouter,
};

export const CALCULATION_VEHICLE_SERVICES_DETAIL_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.calculation.vehicleservices.detail", //"Pregled cestarina",
  icon: "/media/icons/add.svg",
  iconColor: "stroke-[#edeef8]",
  route: CalculationRoutes.CalculationVehicleServicesDetailPageRouter,
};

/*------------------------------------------------------------------
  PRICES
-------------------------------------------------------------------*/

export const PRICE_LIST_SEARCH_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.pricelist.search", //"Cjenik",
  icon: "/media/icons/price.svg",
  iconColor: "stroke-[#edeef8]",
  route: PriceRoutes.PriceListSearchPageRouter,
};

export const PRICE_LIST_CREATE_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.pricelist.create", // "Kreiranje servisa",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: PriceRoutes.PriceListCreatePageRouter,
};

export const PRICE_LIST_EDIT_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.pricelist.edit", //"Ažuriranje servisa",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: PriceRoutes.PriceListEditPageRouter,
};

export const PRICE_LIST_DETAIL_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.pricelist.detail", //"Pregled cestarina",
  icon: "/media/icons/add.svg",
  iconColor: "stroke-[#edeef8]",
  route: PriceRoutes.PriceListDetailPageRouter,
};

/*------------------------------------------------------------------
  INTEGRATIONS
-------------------------------------------------------------------*/


export const INTEGRATION_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.integration", //"Integracije",
  icon: "/media/icons/integration.svg",
  iconColor: "stroke-[#edeef8]",
  route: IntegrationRoutes.IntegrationSearchPageRouter,
};

export const INTEGRATION_SEARCH_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.integration.search", //"Pretraga integracija",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: IntegrationRoutes.IntegrationSearchPageRouter,
};

export const INTEGRATION_SETTINGS_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.integration.settings", //"Postavke integracije",
  icon: "/media/icons/setting.svg",
  iconColor: "stroke-[#edeef8]",
  route: IntegrationRoutes.IntegrationSettingsPageRouter,
};

/*------------------------------------------------------------------
  SALES (PRODAJA)
-------------------------------------------------------------------*/

export const SALES_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.sales",
  icon: "/media/icons/sales.svg",
  iconColor: "stroke-[#edeef8]",
  route: SalesRoutes.ListingSearchPageRouter,
};

export const SALES_INQUIRY_SEARCH_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.sales.inquiry.search",
  icon: "/media/icons/inquiry.svg",
  iconColor: "stroke-[#edeef8]",
  route: SalesRoutes.InquirySearchPageRouter,
};

export const SALES_INQUIRY_DETAIL_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.sales.inquiry.detail",
  icon: "/media/icons/inquiry.svg",
  iconColor: "stroke-[#edeef8]",
  route: SalesRoutes.InquiryDetailPageRouter,
};

export const SALES_LISTING_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.sales.listing",
  icon: "/media/icons/vehicle.svg",
  iconColor: "stroke-[#edeef8]",
  route: SalesRoutes.ListingSearchPageRouter,
};

export const SALES_LISTING_SEARCH_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.sales.listing.search",
  icon: "/media/icons/vehicle.svg",
  iconColor: "stroke-[#edeef8]",
  route: SalesRoutes.ListingSearchPageRouter,
};

export const SALES_LISTING_DETAIL_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.sales.listing.detail",
  icon: "/media/icons/vehicle.svg",
  iconColor: "stroke-[#edeef8]",
  route: SalesRoutes.ListingDetailPageRouter,
};

/*------------------------------------------------------------------
  MARKETPLACE
-------------------------------------------------------------------*/

export const MARKETPLACE_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.marketplace", //"Marketplace",
  icon: "/media/icons/marketplace.svg",
  iconColor: "stroke-[#edeef8]",
  route: MarketplaceRoutes.MarketplaceSearchPageRouter,
};

// Naslov ekrana je opisniji od stavke u meniju ("Pretraži"), pa ima vlastiti ključ.
export const MARKETPLACE_SEARCH_TITLE = "admin.marketplace.search.title"; //"Pretraži vozila"

export const MARKETPLACE_SEARCH_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.marketplace.vehicle.search", //"Pretraga marketplace",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: MarketplaceRoutes.MarketplaceSearchPageRouter,
};

export const MARKETPLACE_DETAIL_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.marketplace.vehicle.detail", //"Marketplace",
  icon: "/media/icons/marketplace.svg",
  iconColor: "stroke-[#edeef8]",
  route: MarketplaceRoutes.MarketplaceDetailPageRouter,
};

/*------------------------------------------------------------------
  NOTIFICATIONS
-------------------------------------------------------------------*/

export const NOTIFICATION_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.notification",
  icon: "/media/icons/notification.svg",
  iconColor: "stroke-[#edeef8]",
  route: NotificationRoutes.NotificationSearchPageRouter,
};

export const NOTIFICATION_SEARCH_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.notification.search",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: NotificationRoutes.NotificationSearchPageRouter,
};

export const NOTIFICATION_CREATE_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.notification.add",
  icon: "/media/icons/add.svg",
  iconColor: "stroke-[#edeef8]",
  route: NotificationRoutes.NotificationCreatePageRouter,
};

export const NOTIFICATION_EDIT_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.notification.edit",
  icon: "/media/icons/edit.svg",
  iconColor: "stroke-[#edeef8]",
  route: NotificationRoutes.NotificationEditPageRouter,
};

export const NOTIFICATION_LOG_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.notification.log",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: NotificationRoutes.NotificationLogSearchPageRouter,
};

export const NOTIFICATION_CALENDAR_PAGE_TITLE: PageTitle = {
  text: "admin.sidebar.notification.calendar",
  icon: "/media/icons/search.svg",
  iconColor: "stroke-[#edeef8]",
  route: NotificationRoutes.NotificationCalendarPageRouter,
};



